import {
  Button,
  Divider,
  InputBase,
  InputAdornment,
  IconButton,
  Checkbox,
  Select,
  MenuItem,
  CircularProgress,
  Box,
  Autocomplete,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  DeleteOutline,
  ErrorOutline,
  KeyboardArrowDown,
  PhoneForwarded,
  PlayCircleFilledOutlined,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import RequireTwilioAccountModal from "../../modals/RequireTwilioAccountModal";
import { json, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { setTokensFromResponse } from "../../../utils/authTokens";
import validator from "validator";
import { jwtDecode } from "jwt-decode";
import SigninWithGoogle from "../SigninWithGoogle";
import generatecode from "../../utils/generateCode";
import CryptoJS from "crypto-js";
import { formatPhoneNumber } from "../../utils/formatnumber";
import posthog from "posthog-js";
import { identifyPostHogUser } from "../../../utils/posthogAnalytics";
import { trackOpenAITrialStarted } from "../../../utils/openaiPixel";
import decryptApi from "../../utils/decryptApi";
import encryptApi from "../../utils/encryptApi";
import { audioBufferToMonoWavBlob } from "../../../utils/audioBufferToMonoWav";
import RegisterNewOrgModal from "../../modals/RegisterNewOrgModal";
import { HelpCircle, EyeOff, Eye, RefreshCw, ArrowRight, Phone, Rocket, User, Mail, Building2, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "../../reusables/Logo";
import { brand } from "../../../theme/brandTokens";

const TWILIO_SETUP_VIDEO_URL =
  "https://xq6zcfzg8yfsx411.public.blob.vercel-storage.com/videos/How%20to%20Integrate%20Twilio%20with%20Twilanswer%20-%20May%202026.m4v";

const Register = () => {
   const [searchParams, setSearchParams] = useSearchParams();
    const [openNewOrgModal, setOpenNewOrgModal] = useState(false);
     useEffect(() => {
       const newOrg = searchParams.get("neworg");
     
       if (!newOrg) return;

       const organization = JSON.parse(localStorage.getItem("organization"));
       setOpenNewOrgModal(true);
       const headerEl = document.getElementById('header-text');
       if (headerEl) {
         headerEl.innerHTML = (organization?.organization_name?.S ?? 'Organization') + ' Setup';
       }
     
       // 2. Remove from URL
       const params = new URLSearchParams(searchParams);
       params.delete("neworg");
       setSearchParams(params, { replace: true });
     
     }, [searchParams, setSearchParams]);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState(1);
  const [forward_action, setSelectedForwardAction] = useState(1);
  const [openRequireModal, setOpenRequireModal] = useState(false);
  const [errorMsg, setErrormsg] = useState(null);
  const [codeSent, setCodeSent] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  //user information
  const [user, setUser] = useState({
    organization_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    userId: JSON.parse(localStorage.getItem("user"))?.userId?.S || null,
    email: JSON.parse(localStorage.getItem("user"))?.email?.S || null,
    password: JSON.parse(localStorage.getItem("user"))?.password?.S || null,
    first_name: JSON.parse(localStorage.getItem("user"))?.fName?.S || null,
    last_name: JSON.parse(localStorage.getItem("user"))?.lName?.S || null,
    company_name:
      JSON.parse(localStorage.getItem("organization"))?.organization_name?.S ||
      null,
    agreed: false,
    registeredFromGoogle:
      JSON.parse(localStorage.getItem("user"))?.registeredFromGoogle?.BOOL ||
      false,
    google_id_token: null,
  });

  //twilio information
  const [twilio_information, setTwilioInformation] = useState({
    organization_id: JSON.parse(localStorage.getItem("organization"))?.orgId?.S,
    account_sid: "",
    api_key: "",
    transcription_enabled: false,
    auto_configuration: true,
    primary_phone: "select",
  });

  //phone numbers
  const [incomming_phonenumbers, setIncommingPhonenumbers] = useState(null);

  //register function

  const registerUser = async () => {
    let err = false;
    if (!user.agreed) {
      setErrormsg("Please accept the terms of service.");
      err = true;
    }

    if (!validator.isEmail(user.email)) {
      setErrormsg("Please fill in a valid email");
      err = true;
    }

    if (!user.first_name || user.first_name.length < 1) {
      setErrormsg("Please fill in first name");
      err = true;
    }

    if (!user.last_name || user.last_name.length < 1) {
      setErrormsg("Please fill in last name");
      err = true;
    }

    if (!user.company_name || user.company_name.length < 1) {
      setErrormsg("Please fill in company name");
      err = true;
    }

    if (!err) {
      setErrormsg(null);
      setLoader(true);
      console.info(
        "[Auth] Sign-up:",
        user.email,
        user.registeredFromGoogle ? "(Google)" : "(email/password)"
      );

      try {
        if (user.registeredFromGoogle) {
          if (!user.google_id_token) {
            setErrormsg("Please sign in with Google first.");
            setLoader(false);
            return;
          }

          const res = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "user/google-signup",
            {
              google_id_token: user.google_id_token,
              company_name: user.company_name,
              email: user.email,
              first_name: user.first_name,
              last_name: user.last_name,
              organization_timezone: user.organization_timezone,
              registered_from_google: true,
            }
          );

          if (res.data.status === "success") {
            localStorage.setItem("user", JSON.stringify(res.data.user));
            localStorage.setItem(
              "organization",
              JSON.stringify(res.data.organization)
            );
            setTokensFromResponse(res.data);
            identifyPostHogUser(res.data.user, res.data.organization);
            posthog.capture("Signed up", {
              email: res.data.user.email.S,
              userId: res.data.user.userId.S,
            });
            trackOpenAITrialStarted();
            setLoader(false);
            navigate("/onboarding");
          } else {
            const backendMsg = res.data.msg || res.data.message;
            setErrormsg(
              backendMsg ? `Sign up failed. ${backendMsg}` : "Sign up failed."
            );
            setLoader(false);
          }
        } else {
          await axios
            .post(process.env.REACT_APP_BACKEND_URL + "create-user", user)
            .then((res) => {
              if (res.data.status === "success") {
                localStorage.setItem("user", JSON.stringify(res.data.user)); //store user data in local storage
                localStorage.setItem(
                  "organization",
                  JSON.stringify(res.data.organization)
                ); //stores organization datat in local storage
                setTokensFromResponse(res.data);
                identifyPostHogUser(res.data.user, res.data.organization);
                posthog.capture("Signed up", {
                  email: res.data.user.email.S,
                  userId: res.data.user.userId.S,
                });
                trackOpenAITrialStarted();
                setLoader(false);
                navigate("/onboarding");
              } else {
                setErrormsg(`Error, account for ${user.email} already exists.`);
                setLoader(false);
              }
            })
            .catch((err) => {
              setLoader(false);
            });
        }
      } catch (error) {
        console.error("Register: registration failed", error.response?.data || error.message || error);
        const backendMsg =
          error.response?.data?.msg || error.response?.data?.message;
        if (user.registeredFromGoogle) {
          setErrormsg(
            backendMsg ? `Sign up failed. ${backendMsg}` : "Sign up failed."
          );
        } else {
          setErrormsg(
            backendMsg
              ? `Sign up failed. ${backendMsg}`
              : "Sign up failed. Please try again."
          );
        }
        setLoader(false);
      }
    }
  };

  const addTwilioInformation = async () => {
    const phone = twilio_information.primary_phone;
    const hasValidPhone =
      phone &&
      phone !== "select" &&
      (validator.isMobilePhone(phone, "any") ||
        /^\+[1-9]\d{6,14}$/.test(phone)); // E.164 format (Twilio)
    if (!hasValidPhone) {
      setErrormsg(
        "issues with credentials. Please select a primary phone number"
      );
      return;
    }
    setErrormsg(null);
    setLoader(true);
    try {
      let t = twilio_information;
      await axios
        .post(
          process.env.REACT_APP_BACKEND_URL + "add-org-twilio_information",
          {
            ...t,
            organization_id: JSON.parse(localStorage.getItem("organization"))
              ?.orgId?.S,
          }
        )
        .then((res) => {
          if (res.data.status === "success") {
            localStorage.setItem(
              "organization",
              JSON.stringify(res.data.organization)
            ); //stores organization datat in local storage
            setLoader(false);
            setStep(step + 1);
          } else {
            setErrormsg("Some error occured , try again");
            setLoader(false);
          }
        })
        .catch((err) => {
          // Log for production diagnostics when add-org-twilio_information fails
          console.error("Register: add Twilio information failed", err.response?.data || err.message || err);
          if (err.response && err.response.data) {
            setErrormsg(err.response.data.message);
          }
          setLoader(false);
        });
    } catch (error) {
      // Log for production diagnostics when add-org-twilio_information fails
      console.error("Register: add Twilio information failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  // forward number
  const [forward_number, setForwardNumber] = useState("");
  const [verificationCode, setVerificationCode] = useState(null);
  const [verificationCodeConfirmation, setVerificationCodeConfirmation] =
    useState(null);

  //verify phone number
  const [loader2, setLoader2] = useState(false);
  const [code, setCode] = useState(null);
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    setCode(generatecode());
    setCodeSent(false);
  }, [forward_number]);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    if (timeLeft === 0) {
      setCode(generatecode());
    }
    return () => clearInterval(intervalId); // Cleanup on unmount or re-render
  }, [timeLeft]);
  async function sendPhoneVerificationText() {
    setErrormsg(null);

    setLoader(true);
    try {
      const ciphertext = CryptoJS.AES.encrypt(
        code,
        process.env.REACT_APP_TWILANSWER_SECRET
      ).toString();
      let response = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "twilio/read-num-aloud",
        {
          organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
          fromNumber: JSON.parse(localStorage.getItem("organization"))
            ?.twilio_integration?.M?.primary_phone?.S,
          forwarding_number: forward_number,
          code: await encryptApi(code),
        }
      );
      setCodeSent(true);
      setTimeLeft(60);

      setLoader(false);
    } catch (error) {
      // Log for production diagnostics when verification call fails
      console.error("Register: send verification code failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrormsg(error.response.data.error);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
      setLoader(false);
    }
  }

  //recording
  const [recording, setRecording] = useState(null);

  //create channel and route
  const completeOnboardingforFowardedCall = async () => {
    setErrormsg(null);
    if (forward_action === 1) {
      try {
        setLoader(true);
        let channel = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-channel",
          {
            label: "Forwarding Number 1",
            last_updated: String(Math.floor(Date.now() / 1000)),
            status: "active",
            type: "forward_number",
            value: String(forward_number),
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            slack_id: "",
            api_key: "",
            front_id: "",
          }
        );

        let channel_data = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-channel",
          {
            label: "my email",
            last_updated: String(Math.floor(Date.now() / 1000)),
            status: "active",
            type: "email",
            value: user.email,
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            slack_id: "",
            api_key: "",
            front_id: "",
          }
        );

        let route = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "route/create-route",
          {
            name: "Route 1",
            configured_phone: JSON.parse(localStorage.getItem("organization"))
              .twilio_integration.M.primary_phone.S,
            org_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            // early_time: "12:00 AM",
            // late_time: "11:59 PM",
            primaryAction: forward_action === 1 ? "forward" : "forwardvwm",
            primaryRecording: "",
            primary_number: String(forward_number),
            primaryChannel: channel_data.data.channel_id,
            offHoursAction: "",
            offHoursRecording: "",
            offHoursNumber: "",
            offHoursChannel: "",
            calendar : null,
            ivrMenu: null,
            offHoursIvrMenu: null,
          }
        );

        let organization = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-route",
          {
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            route_id: route.data.route.routeId.S,
          }
        );

        localStorage.setItem(
          "organization",
          JSON.stringify(organization.data.organization)
        );

        let t = JSON.parse(localStorage.getItem("organization"))
          .twilio_integration.M;

        if (t?.auto_configuration?.BOOL) {
          let update_voice = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "twilio/update-voice-url",
            {
              org_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
              phone_number: t.primary_phone.S,
              webhook_url: `https://incoming.twilanswer.com/${route.data.route.routeId.S}`,
            }
          );
        }
        setLoader(false);
        navigate("/dashboard/call-route/" + route.data.route.routeId.S);
        localStorage.setItem("show_confetti", true);
      } catch (error) {
        // Log for production diagnostics when onboarding (forward) fails
        console.error("Register: completeOnboarding (forward) failed", error.response?.data || error.message || error);
        setLoader(false);
        setErrormsg(error.message);
      }
    } else {
      try {
        setLoader(true);

        //upload recording
        const formData = new FormData();
        if (audioBlob) {
          formData.append(
            "file",
            audioBlob,
            `${recording_data.title}-${Date.now()}.${
              audioBlob.type.split("/")[1]
            }`
          );
        } else {
          formData.append(
            "file",
            uploadedFile,
            `${recording_data.title}-${Date.now()}.${uploadedFile.name
              .split(".")
              .pop()
              .toLowerCase()}`
          );
        }

        const recording = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "upload",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        let record = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-recording",
          {
            title: recording_data.title,
            type: record_type,
            url: recording.data.url,
            original_url: recording.data.original_url,
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
          }
        );

        let channel_data = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-channel",
          {
            label: "my email",
            last_updated: String(Math.floor(Date.now() / 1000)),
            status: "active",
            type: "email",
            value: user.email,
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            slack_id: "",
            api_key: "",
            front_id: "",
          }
        );

        let route = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "route/create-route",
          {
            name: "Route 1",
            configured_phone: JSON.parse(localStorage.getItem("organization"))
              .twilio_integration.M.primary_phone.S,
            org_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            // early_time: "12:00 AM",
            // late_time: "11:59 PM",
            primaryAction: forward_action === 1 ? "forward" : "forwardvwm",
            primaryRecording: record.data.rec_id,
            primaryNumber: "",
            primaryChannel: channel_data.data.channel_id,
            offHoursAction: "",
            offHoursRecording: "",
            offHoursNumber: "",
            offHoursChannel: "",
            calendar : null,
            ivrMenu: null,
            offHoursIvrMenu: null,
          }
        );

        let t = JSON.parse(localStorage.getItem("organization"))
          .twilio_integration.M;

        if (t?.auto_configuration?.BOOL) {
          let update_voice = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "twilio/update-voice-url",
            {
              org_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
              phone_number: t.primary_phone.S,
              webhook_url: `https://incoming.twilanswer.com/${route.data.route.routeId.S}`,
            }
          );
        }

        let organization = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "add-route",
          {
            organization_id: JSON.parse(localStorage.getItem("organization"))
              .orgId.S,
            route_id: route.data.route.routeId.S,
          }
        );

        localStorage.setItem(
          "organization",
          JSON.stringify(organization.data.organization)
        );

        setLoader(false);
        setRecordings(organization.data.organization.recordings.L);
        restartRecording();
        setRecordingData({ title: "" });
        setLoader(false);
        setErrorMsg(null);
        navigate("/dashboard/call-route/" + route.data.route.routeId.S);
        localStorage.setItem("show_confetti", true);
      } catch (error) {
        // Log for production diagnostics when onboarding (recording) fails
        console.error("Register: completeOnboarding (recording) failed", error.response?.data || error.message || error);
        setLoader(false);
        setErrormsg(error.message);
      }
    }
  };

  const [loader1, setLoader1] = useState(false);
  async function getIncomingPhoneNumbers() {
    setLoader1(true);
    setErrormsg(null);
    try {
      await axios
        .post(
          process.env.REACT_APP_BACKEND_URL +
            "twilio/get-incoming-phone-numbers",
          {
            org_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
            ...twilio_information,
            api_key: await encryptApi(twilio_information.api_key),
          }
        )
        .then((res) => {
          if (res.data.length < 1) {
            setErrormsg(
              "Please add an incoming phone number in your twilio account"
            );
            setLoader1(false);
          } else {
            setIncommingPhonenumbers(res.data);
            setLoader1(false);
          }
        })
        .catch((err) => {
          // Log for production diagnostics when get-incoming-phone-numbers fails
          console.error("Register: getIncomingPhoneNumbers failed", err.response?.data || err.message || err);
          setErrormsg("wrong account_sid or api key");
          setLoader1(false);
          setIncommingPhonenumbers([]);
          setTwilioInformation({ ...twilio_information, primary_phone: "" });
        });
    } catch (error) {
      // Log for production diagnostics when getIncomingPhoneNumbers throws
      console.error("Register: getIncomingPhoneNumbers failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
  }

  function generateVerificationCode() {
    return Math.floor(100000 + Math.random() * 900000); // Generates a random 6-digit number
  }

  useEffect(() => {
    setErrorMsg(null);
    setVerificationCode(generateVerificationCode());
  }, []);

  //recording mods
  const [record_type, setRecordType] = useState("upload_mp3");
  const [uploadedFile, setUploadedFile] = useState(null);

  const [buttonState, setButtonState] = useState("record"); // "record", "stop", "play"
  const [time, setTime] = useState(0); // Timer in seconds
  const [maxTime, setMaxTime] = useState(30); // Timer in seconds
  const [audioBlob, setAudioBlob] = useState(null); // Stores the recorded audio
  const [isRecording, setIsRecording] = useState(false); // Tracks recording state
  const mediaRecorderRef = useRef(null); // MediaRecorder reference
  const audioUrlRef = useRef(null); // URL for the audio playback
  const mediaStreamRef = useRef(null); // Stores the media stream
  const [recording_data, setRecordingData] = useState({
    title: "",
    type: "",
  });

  // Handle button click to toggle states and recording
  const handleClick = () => {
    if (buttonState === "record") {
      startRecording();
      setButtonState("stop");
    } else if (buttonState === "stop") {
      stopRecording();
      setButtonState("play");
    } else if (buttonState === "play") {
      playRecording();
      setButtonState("playing");
    } else if (buttonState === "playing") {
      stopPlaying();
      setButtonState("play");
    }
  };

  // Start recording
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaStreamRef.current = stream;

      const audioContext = new AudioContext();
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;

      const chunks = [];
      mediaRecorder.ondataavailable = (event) => chunks.push(event.data);

      mediaRecorder.onstop = async () => {
        const rawAudioBlob = new Blob(chunks, { type: "audio/webm" });
        const arrayBuffer = await rawAudioBlob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        const processedAudioBlob = audioBufferToMonoWavBlob(audioBuffer);

        setAudioBlob(processedAudioBlob);
        audioUrlRef.current = URL.createObjectURL(processedAudioBlob);
        setIsRecording(false);
      };

      mediaRecorder.onstart = () => {
        setIsRecording(true);
        setTimeout(() => {
          if (mediaRecorder.state === "recording") {
            mediaRecorder.stop();
            stopRecording();
          }
        }, 30000);
      };

      mediaRecorder.start();
    } catch (error) {
      // Log when user denies mic or device unavailable
      console.error("Error accessing microphone:", error);
    }
  };

  // Stop recording and turn off the microphone
  const stopRecording = () => {
    setIsRecording(false); // Stop the timer
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }
    // Stop the microphone stream
    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach((track) => track.stop()); // Stop all tracks (including audio)
    }
  };

  const audioRef = useRef(null);
  const intervalIdRef = useRef(null);

  const [currentTime, setCurrentTime] = useState(0);

  const playRecording = () => {
    if (audioUrlRef.current) {
      if (!audioRef.current) {
        // Create a new audio instance if not already created
        audioRef.current = new Audio(audioUrlRef.current);

        // Set the max time to the length of the audio (in seconds)
        setMaxTime(30);
      }

      audioRef.current.currentTime = 0; // Start from the beginning of the audio
      audioRef.current.play();

      // Clear any previous interval and start a new timer
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }

      intervalIdRef.current = setInterval(() => {
        // Update current time based on audio playback
        setCurrentTime(audioRef.current.currentTime);
        if (audioRef.current.currentTime >= maxTime) {
          clearInterval(intervalIdRef.current); // Stop the timer once the audio finishes
          intervalIdRef.current = null;
        }
      }, 1000); // Update every second to match audio playback

      audioRef.current.onended = () => {
        // Update the button state to "playing"
        setButtonState("play"); // Make sure you have this state defined
        stopPlaying(); // Stop the audio and the timer
      };
    }
  };

  const stopPlaying = () => {
    if (audioRef.current) {
      audioRef.current.pause(); // Pause the audio
    }
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current); // Stop the timer
      intervalIdRef.current = null;
    }
  };

  // Restart recording (reset state and start over)
  const restartRecording = () => {
    stopRecording(); // First stop any ongoing recording
    setTime(0); // Reset the timer
    setAudioBlob(null); // Clear the previous audio
    setButtonState("record"); // Reset to "record" button
    setMaxTime(30);
    mediaStreamRef.current = null;
    audioRef.current = null;
    audioUrlRef.current = null;
    mediaRecorderRef.current = null;
    intervalIdRef.current = null;
  };

  // Timer logic for recording
  useEffect(() => {
    let timerInterval;
    let t = 0;
    if (isRecording) {
      timerInterval = setInterval(() => {
        if (t < maxTime) {
          t += 1;
          setTime((prev) => prev + 1);
        } else {
          stopRecording();
        }
      }, 1000);
    } else {
      clearInterval(timerInterval);
    }
    return () => clearInterval(timerInterval);
  }, [isRecording]);

  // Format time as mm:ss
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
  };
  const [err_msg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false);

  //recordings

  const [recordings, setRecordings] = useState(
    JSON.parse(localStorage.getItem("organization"))?.recordings?.L || []
  );

  function decodeToken(token) {
    try {
      const decoded = jwtDecode(token);
      return decoded.api_key;
    } catch (error) {
      // Log when channel/invite token is invalid
      console.error("Invalid token:", error);
      return null;
    }
  }

  //change the primary phone state whenevver account sid or auth token changes
  useEffect(() => {
    if (
      twilio_information.account_sid.length >= 34 &&
      twilio_information.api_key.length >= 34
    ) {
      getIncomingPhoneNumbers();
    }
  }, [twilio_information.account_sid, twilio_information.api_key]);

  //check if user has twilio_information and exist
  useEffect(() => {
    setErrormsg(null);
    let organization = JSON.parse(localStorage.getItem("organization"));
    if (organization && !organization.twilio_integration) {
      // Redirect to onboarding if they haven't completed Twilio setup
      navigate("/onboarding");
    }
    if (
      organization &&
      organization.twilio_integration &&
      !organization.routes
    ) {
      // Redirect to onboarding step 2 if they haven't set up call actions
      navigate("/onboarding");
    }
    if (
      organization &&
      organization.twilio_integration &&
      organization.routes
    ) {
      navigate("/dashboard/call-routings");
    }
  }, [navigate]);

  useEffect(() => {
    if (errorMsg) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [errorMsg]);

  const [loadState, setLoadState] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoadState(false);
    }, 2000);
  }, []); // Runs only once when the component mounts

  return (
    <div className="w-full">
    <RegisterNewOrgModal open={openNewOrgModal} setOpen={setOpenNewOrgModal} />
      {/* {loadState && (
         <div
         style={{
           position: "fixed",
           top: 0,
           left: 0,
           width: "100vw",
           height: "100vh",
           backdropFilter: "blur(10px)",
           backgroundColor: "rgba(0, 0, 0, 0.5)",
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
           zIndex: 9999,
         }}
       >
         <Box>
           <div className="flex items-center text-white text-[15px]">
           <div style={{ display: "flex", gap: "0.5rem", marginRight: '5px' }}>
           <span className="dot"></span>
           <span className="dot"></span>
           <span className="dot"></span>
         </div>
         <style jsx>{`
           .dot {
             width: 12px;
             height: 12px;
             background-color: #fff;
             border-radius: 50%;
             animation: bounce 1.5s infinite;
           }
           .dot:nth-child(2) {
             animation-delay: 0.2s;
           }
           .dot:nth-child(3) {
             animation-delay: 0.4s;
           }
           @keyframes bounce {
             0%, 80%, 100% {
               transform: scale(0);
             }
             40% {
               transform: scale(1);
             }
           }
         `}</style>
              Twilanswer loading </div>
         </Box>
       </div>
      )} */}
      <div className="min-h-screen bg-gray-50 flex flex-col py-8 sm:px-6 lg:px-8">
        {step === 1 ? (
          <div className="mx-auto w-full max-w-md px-4">
            {/* Logo - avoid mb-6 class (index.css overrides it with display:block !important) */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1.5rem' }}>
              <Logo size="lg" />
            </div>

            {/* Title */}
            <h1 id="header-text" className="text-2xl font-bold text-gray-900 text-center">
              Create your account
            </h1>
            <p className="text-sm text-gray-600 text-center mt-1 mb-6">
              Or <Link to="/login" className="text-brand-primary hover:text-brand-hover font-medium">sign in to your existing account</Link>
            </p>

            {/* Form card */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8">
              {errorMsg && (
                <div className="mb-4 p-3 rounded-lg bg-red-50 text-red-600 text-sm flex items-center gap-2">
                  <ErrorOutline sx={{ fontSize: 18 }} />
                  {errorMsg}
                </div>
              )}

              <div className="mb-5">
                <SigninWithGoogle
                  page="register"
                  user={user}
                  setErrormsg={setErrormsg}
                  setStep={setStep}
                  step={step}
                  loader={loader}
                  setLoader={setLoader}
                  setUser={setUser}
                />
              </div>

              <div className="flex items-center gap-3 mb-5">
                <div className="flex-1 h-px bg-gray-200" />
                <span className="text-sm text-gray-500">Or continue with</span>
                <div className="flex-1 h-px bg-gray-200" />
              </div>

              <div className="space-y-3">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-900 mb-1">First Name</label>
                    <div className="relative">
                      <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <User size={16} />
                      </div>
                      <InputBase
                        value={user.first_name}
                        onChange={(e) => setUser({ ...user, first_name: e.target.value })}
                        placeholder="First name"
                        sx={{
                          bgcolor: "#fff",
                          width: "100%",
                          pl: "36px",
                          pr: 2,
                          py: "6px",
                          fontSize: "14px",
                          borderRadius: "10px",
                          border: "1px solid #D1D5DB",
                          minHeight: 38,
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-900 mb-1">Last Name</label>
                    <div className="relative">
                      <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                        <User size={16} />
                      </div>
                      <InputBase
                        value={user.last_name}
                        onChange={(e) => setUser({ ...user, last_name: e.target.value })}
                        placeholder="Last name"
                        sx={{
                          bgcolor: "#fff",
                          width: "100%",
                          pl: "36px",
                          pr: 2,
                          py: "6px",
                          fontSize: "14px",
                          borderRadius: "10px",
                          border: "1px solid #D1D5DB",
                          minHeight: 38,
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-1">Email Address</label>
                  <div className="relative">
                    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                      <Mail size={16} />
                    </div>
                    <InputBase
                      value={user.email}
                      disabled={user.registeredFromGoogle}
                      onChange={(e) => setUser({ ...user, email: e.target.value.toLowerCase() })}
                      placeholder="Enter your email"
                      sx={{
                        bgcolor: "#fff",
                        width: "100%",
                        pl: "36px",
                        pr: 2,
                        py: "6px",
                        fontSize: "14px",
                        borderRadius: "10px",
                        border: "1px solid #D1D5DB",
                        minHeight: 38,
                      }}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-900 mb-1">Company Name</label>
                  <div className="relative">
                    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                      <Building2 size={16} />
                    </div>
                    <InputBase
                      id="register-company-name"
                      value={user.company_name}
                      onChange={(e) => setUser({ ...user, company_name: e.target.value })}
                      placeholder="Enter your company name"
                      sx={{
                        bgcolor: "#fff",
                        width: "100%",
                        pl: "36px",
                        pr: 2,
                        py: "6px",
                        fontSize: "14px",
                        borderRadius: "10px",
                        border: "1px solid #D1D5DB",
                        minHeight: 38,
                      }}
                    />
                  </div>
                </div>

                {!user.registeredFromGoogle && (
                  <>
                    <div>
                      <label className="block text-sm font-semibold text-gray-900 mb-1">Password</label>
                      <div className="relative">
                        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                          <Lock size={16} />
                        </div>
                        <InputBase
                          type={showPassword ? "text" : "password"}
                          value={user.password}
                          onChange={(e) => setUser({ ...user, password: e.target.value })}
                          placeholder="Create a password"
                          sx={{
                            bgcolor: "#fff",
                            width: "100%",
                            pl: "36px",
                            pr: "36px",
                            py: "6px",
                            fontSize: "14px",
                            borderRadius: "10px",
                            border: "1px solid #D1D5DB",
                            minHeight: 38,
                          }}
                        />
                        <button
                          type="button"
                          onClick={handleTogglePassword}
                          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 p-1"
                        >
                          {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                        </button>
                      </div>
                    </div>

                  </>
                )}

                <div className="flex items-start gap-3 pt-1">
                  <Checkbox
                    checked={user.agreed || false}
                    onChange={(e) => setUser({ ...user, agreed: e.target.checked })}
                    color="primary"
                    sx={{ padding: "4px" }}
                  />
                  <label className="text-sm text-gray-600 mt-0.5">
                    I agree to the{" "}
                    <a href="https://twilanswer.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="text-brand-primary hover:underline">
                      Terms of Use
                    </a>{" "}
                    and{" "}
                    <a href="https://twilanswer.com/privacy" target="_blank" rel="noopener noreferrer" className="text-brand-primary hover:underline">
                      Privacy Policy
                    </a>
                  </label>
                </div>

                <Button
                  fullWidth
                  onClick={registerUser}
                  disabled={loader}
                  variant="contained"
                    color="primary"
                    sx={{                    py: "12px",
                    borderRadius: "8px",
                    fontSize: "15px",
                    fontWeight: 600,
                    "&:disabled": { bgcolor: "#9CA3AF", color: "white" },
                  }}
                >
                  {loader ? <CircularProgress size={22} sx={{ color: "white" }} /> : "Create account"}
                </Button>
              </div>
            </div>

            <p className="text-center text-sm text-gray-600 mt-6">
              Already have an account?{" "}
              <Link to="/login" className="text-brand-primary hover:text-brand-hover font-medium">
                Log in
              </Link>
            </p>
          </div>

        ) : (
          <>
            {/* Onboarding Steps (2 & 3) - Full Width Layout */}
            <div className="w-full">
            {/* Header with Branding and Progress Status - Full Width */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
              <div className="max-w-7xl mx-auto px-8 py-6">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center space-x-3">
                    <div className="flex items-center">
                      <Phone className="w-6 h-6 text-brand-primary" />
                      <span className="ml-2 text-xl font-bold text-brand-primary">Twilanswer</span>
                    </div>
                    <div className="flex items-center bg-pink-500 text-white px-3 py-1.5 rounded-full">
                      <Rocket className="w-4 h-4 mr-1.5" />
                      <span className="text-sm font-medium">Setup Wizard</span>
                    </div>
                  </div>
                  <div className="text-sm text-gray-600">
                    Step {step === 2 ? '1' : '2'} of 2 · Almost there! 🎉
                  </div>
                </div>

                {/* Progress Bar */}
                <div className="flex items-center">
                  {/* Step 1: Twilio Setup */}
                  <div className="flex items-center">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center ${step >= 2 ? 'bg-brand-primary' : 'bg-gray-300'}`}>
                      <span className={`font-semibold text-sm ${step >= 2 ? 'text-white' : 'text-gray-600'}`}>1</span>
                    </div>
                    <span className={`ml-2 text-sm font-medium ${step >= 2 ? 'text-brand-primary' : 'text-gray-400'}`}>
                      Twilio Setup
                    </span>
                  </div>
                  
                  {/* Connector Line */}
                  <div className={`flex-1 mx-4 ${step >= 3 ? 'h-1.5 bg-brand-primary' : 'h-0.5 bg-gray-300'}`}></div>
                  
                  {/* Step 2: Call Action */}
                  <div className="flex items-center">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${step >= 3 ? 'bg-brand-primary border-brand-primary' : 'bg-white border-gray-300'}`}>
                      <span className={`font-semibold text-sm ${step >= 3 ? 'text-white' : 'text-gray-400'}`}>2</span>
                    </div>
                    <span className={`ml-2 text-sm font-medium ${step >= 3 ? 'text-brand-primary' : 'text-gray-400'}`}>
                      Call Action
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Main Content Area - Full Width with Centered Content */}
            <div className="max-w-7xl mx-auto px-8 py-8">
              {errorMsg && (
                <div className="mb-4 text-center text-red-500 lg:text-[13px] text-[12px] font-semibold">
                  <ErrorOutline sx={{ fontSize: "" }} /> {errorMsg}
                </div>
              )}

          {step === 2 && (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
              <div className="mb-8">
                <div className="flex items-center mb-4">
                  <div className="text-4xl mr-3">📞</div>
                  <h1 className="text-2xl font-bold text-gray-900">Connect Your Twilio Account</h1>
                </div>
                <p className="text-gray-600">
                  We need your Twilio account information to handle your phone calls. Don't have a Twilio account yet?{' '}
                  <a href="https://www.twilio.com/try-twilio" target="_blank" rel="noopener noreferrer" className="text-brand-primary hover:text-brand-primary/80 font-medium">
                    Sign up here
                  </a>
                </p>
              </div>

              {/* Help Resources */}
              <div className="mb-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
                <h3 className="text-sm font-medium text-blue-900 mb-2">🤔 Need Help?</h3>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="https://twilanswer.com/docs/how-to-integrate-twilio-with-twilanswer/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-sm text-blue-700 hover:text-blue-600"
                  >
                    <HelpCircle size={16} className="mr-1" />
                    View Setup Guide
                  </a>
                  <button
                    onClick={() => setShowVideo(!showVideo)}
                    className="inline-flex items-center text-sm text-blue-700 hover:text-blue-600 cursor-pointer"
                  >
                    📺 Watch our setup video {showVideo ? '⬆️' : '⬇️'}
                  </button>
                </div>
              </div>

              {/* Embedded Video */}
              {showVideo && (
                <div className="mb-8 text-center">
                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <h4 className="text-sm font-medium text-gray-700">Twilio Setup Tutorial</h4>
                    </div>
                    <div className="relative w-full overflow-hidden rounded-lg bg-black" style={{ aspectRatio: "16 / 9" }}>
                      <video
                        className="absolute inset-0 h-full w-full"
                        controls
                        playsInline
                        preload="auto"
                        aria-label="Twilio Setup Tutorial"
                      >
                        <source src={TWILIO_SETUP_VIDEO_URL} type="video/mp4" />
                      </video>
                    </div>
                  </div>
                </div>
              )}

              <div className="space-y-6">
              <div className="lg:hidden">
                <div className="text-center lg:text-[18px] text-[15px] font-[500] mb-3">
                  How to Configure Twilio
                </div>
                <p className="text-center text-[12px] lg:text-[13px] mb-3 text-gray-600">
                  Use <span className="font-medium text-gray-800">Watch our setup video</span> above for a full walkthrough.
                </p>

                <div className="text-black text-center lg:text-[13px]   text-[12px] ">
                  More info on our{" "}
                  <span
                    className="text-brand-primary cursor-pointer hover:underline  "
                    onClick={() => {
                      window.open(
                        "https://twilanswer.com/docs/how-to-integrate-twilio-with-twilanswer/",
                        "_blank"
                      );
                    }}
                  >
                    help page
                  </span>
                </div>
              </div>
              <div className="text-center lg:text-[16px] text-[14px] font-[500] mb-3">
                Let’s get your Twilio connection info
              </div>

                {/* Account SID */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Account SID
                  </label>
                  <input
                    type="text"
                    value={twilio_information.account_sid}
                    onChange={(e) => {
                      setTwilioInformation({
                        ...twilio_information,
                        account_sid: e.target.value,
                      });
                    }}
                    maxLength={34}
                    minLength={34}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-brand-primary"
                    placeholder="AC1234567890abcdef1234567890abcdef"
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    Found in your Twilio Console dashboard
                  </p>
                </div>

                {/* Auth Token */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Auth Token
                  </label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={twilio_information.api_key}
                      onChange={(e) => {
                        setTwilioInformation({
                          ...twilio_information,
                          api_key: e.target.value,
                        });
                      }}
                      maxLength={34}
                      minLength={34}
                      className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-brand-primary"
                      placeholder="Your Twilio Auth Token"
                    />
                    <button
                      type="button"
                      onClick={handleTogglePassword}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center"
                    >
                      {showPassword ? (
                        <EyeOff size={16} className="text-gray-400" />
                      ) : (
                        <Eye size={16} className="text-gray-400" />
                      )}
                    </button>
                  </div>
                  <p className="mt-1 text-xs text-gray-500">
                    Found in your Twilio Console dashboard (keep this secure!)
                  </p>
                </div>

              <div className="space-y-1 mb-3">
                <div className="flex justify-between items-center">
                  <div className=" lg:text-[14px] text-[13px] ">
                    Primary Phone Number
                  </div>
                  <div className=" space-x-2">
                    <Button
                      variant="contained"
                        color="primary"
                        sx={{                        py: "1px",
                        px: { lg: "6px", xs: "10px" },
                        borderRadius: "7px",
                        fontSize: { lg: "13px", xs: "13px" },
                        width: "fit",
                      }}
                      onClick={getIncomingPhoneNumbers}
                    >
                      {loader1 ? (
                        <CircularProgress
                          size={"1rem"}
                          sx={{ color: "white" }}
                        />
                      ) : (
                        " Load Numbers"
                      )}
                    </Button>
                  </div>
                </div>

                <div className="text-[11px] my-1">
                  The main phone number you’d like to setup call forwarding for.
                  You can change this later in settings.
                </div>
                <div className="flex space-x-2">
                  <select
                    value={twilio_information.primary_phone === "select" ? "" : twilio_information.primary_phone}
                    onChange={(e) => {
                      setTwilioInformation({
                        ...twilio_information,
                        primary_phone: e.target.value,
                      });
                    }}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-brand-primary"
                  >
                    <option value="">Select a phone number</option>
                    {incomming_phonenumbers?.map((number) => (
                      <option key={number.phoneNumber} value={number.phoneNumber}>
                        {formatPhoneNumber(number.phoneNumber)}
                      </option>
                    ))}
                  </select>
                  <button
                    onClick={getIncomingPhoneNumbers}
                    disabled={loader1}
                    className="px-3 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-primary disabled:opacity-50"
                  >
                    {loader1 ? (
                      <CircularProgress size={"1rem"} color="primary" />
                    ) : (
                      <RefreshCw size={16} className={loader1 ? 'animate-spin' : ''} />
                    )}
                  </button>
                </div>
                  <p className="mt-1 text-xs text-gray-500">
                    The main phone number you'd like to setup call forwarding for. You can change this later in settings.
                  </p>
                </div>

                {/* Autoconfiguration */}
                <div>
                  <div className="flex items-center space-x-3">
                    <div className="flex items-center">
                      <label className="text-sm font-medium text-gray-700">
                        Autoconfiguration
                      </label>
                      <div className="inline-flex items-center ml-2">
                        <HelpCircle 
                          size={14} 
                          className="text-gray-400 cursor-help" 
                          title="Automatically configure Twilio webhooks and settings"
                        />
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setTwilioInformation({
                          ...twilio_information,
                          auto_configuration: !twilio_information.auto_configuration,
                        });
                      }}
                      className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 ${
                        twilio_information.auto_configuration ? 'bg-brand-primary' : 'bg-gray-200'
                      }`}
                    >
                      <span
                        className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                          twilio_information.auto_configuration ? 'translate-x-5' : 'translate-x-0'
                        }`}
                      />
                    </button>
                    <span className="text-sm text-green-600 font-medium">Recommended</span>
                  </div>
                  <p className="mt-2 text-xs text-gray-500">
                    Would you like us to update the incoming call settings to point to Twilanswer automatically, or would you like to do that manually later?
                  </p>
                </div>
              </div>

              {/* Continue Button */}
              <div className="flex justify-end mt-8">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    addTwilioInformation();
                  }}
                  disabled={loader || !twilio_information.account_sid || !twilio_information.api_key || !twilio_information.primary_phone || twilio_information.primary_phone === "select"}
                  sx={{
                    px: 3,
                    py: 1.5,
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: 500,
                    borderRadius: "0.375rem",
                  }}
                >
                  {loader ? (
                    <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                  ) : (
                    <>
                      Continue
                      <ArrowRight size={20} className="ml-2 inline align-middle" />
                    </>
                  )}
                </Button>
              </div>

              {/* <div className="text-brand-primary text-center lg:text-[13px] lg:absolute  bottom-4 cursor-pointer hover:underline lg:left-[34%] left-[35%]   text-[12px] ">
                Skip Guided Setup
              </div> */}
            </div>
          )}

          {step === 3 && (
            <div className="mt-[50px]">
              <div className="lg:hidden">
                <div className="text-center lg:text-[18px] text-[15px] font-[500] mb-3">
                  Forward Action Option
                </div>
                <iframe
                  width="100%"
                  height="200"
                  src="https://www.youtube.com/embed/Hn1-di--OCI?si=QKqwFXLiHLRHqEcB"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>

                <div className="text-black text-center lg:text-[13px]   text-[12px] ">
                  More info on our{" "}
                  <span
                    className="text-brand-primary cursor-pointer hover:underline  "
                    onClick={() => {
                      window.open(
                        "https://twilanswer.com/docs/how-to-create-a-twilanswer-account/",
                        "_blank"
                      );
                    }}
                  >
                    help page
                  </span>
                </div>
              </div>
              <div className="text-center lg:text-[16px] text-[14px] font-[500] mb-3">
                Setup your forward action
              </div>

              <div className="flex justify-center pt-6 pb-4 space-x-5">
                <div
                  className={
                    forward_action === 1
                      ? "flex items-center border-[1px] border-brand-primary text-brand-primary text-[15px] py-1 px-3 rounded-[10px] cursor-pointer"
                      : "flex items-center border-[1px] border-[#9A9AA9] text-[#9A9AA9] text-[15px] py-1 px-3 rounded-[10px] cursor-pointer"
                  }
                  onClick={() => setSelectedForwardAction(1)}
                >
                  <PhoneForwarded
                    sx={
                      forward_action === 1
                        ? { color: brand.primary, fontSize: "25px" }
                        : { color: "#9A9AA9", fontSize: "25px" }
                    }
                  />
                  <div className="text-center"> Forwarded Call </div>
                </div>

                <div
                  className={
                    forward_action === 2
                      ? "flex items-center border-[1px] border-brand-primary text-brand-primary text-[15px] py-1 px-3 rounded-[10px] cursor-pointer"
                      : "flex items-center border-[1px] border-[#9A9AA9] text-[#9A9AA9] text-[15px] py-1 px-3 rounded-[10px] cursor-pointer"
                  }
                  onClick={() => setSelectedForwardAction(2)}
                >
                  <PlayCircleFilledOutlined
                    sx={
                      forward_action === 2
                        ? { color: brand.primary, fontSize: "25px" }
                        : { color: "#9A9AA9", fontSize: "25px" }
                    }
                  />
                  <div className="text-center"> Play Recording </div>
                </div>
              </div>

              {forward_action === 1 && (
                <div className="mb-20">
                  <div className="text-[13px] text-[#030229] text-center mb-5">
                    Forward incoming calls to another phone number.
                  </div>

                  <div className="space-y-1 mb-7">
                    <div className=" lg:text-[14px] text-[13px] ">
                      Forward Number
                    </div>
                    <div className="flex items-center space-x-2">
                      <InputBase
                        value={forward_number}
                        onChange={(e) => {
                          setForwardNumber(e.target.value);
                        }}
                        sx={{
                          bgcolor: "#F7F7F8",
                          width: "100%",
                          px: 2,
                          py: "2px",
                          fontSize: "14px",
                        }}
                      />
                      {timeLeft >= 1 ? (
                        <Button
                          variant="contained"
                            color="primary"
                            sx={{                            py: "1px",
                            px: "10px",
                            borderRadius: "7px",
                            fontSize: { lg: "13px", xs: "12px" },
                          }}
                        >
                          Expires({timeLeft})
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                            color="primary"
                            sx={{                            py: "4px",
                            px: "10px",
                            borderRadius: "7px",
                            fontSize: { lg: "14px", xs: "13px" },
                            width: "fit",
                          }}
                          onClick={sendPhoneVerificationText}
                        >
                          {loader ? (
                            <CircularProgress
                              size={"1.3rem"}
                              sx={{ color: "white" }}
                            />
                          ) : (
                            " Verify"
                          )}
                        </Button>
                      )}
                    </div>
                  </div>

                  <div className="space-y-1 mb-3 mt-3" hidden={!codeSent}>
                    <div className=" lg:text-[14px] text-[13px] ">
                      Verification Code
                    </div>

                    <InputBase
                      value={verificationCodeConfirmation}
                      onChange={(e) => {
                        setVerificationCodeConfirmation(e.target.value);
                      }}
                      sx={{
                        bgcolor: "#F7F7F8",
                        width: "75%",
                        px: 2,
                        py: "2px",
                        fontSize: "14px",
                      }}
                    />
                  </div>
                </div>
              )}

              {forward_action === 2 && (
                <div className="mb-12">
                  <div className="text-[13px] text-[#030229] text-center mb-5">
                    Play an audio recording when people call.
                  </div>

                  <div className="space-y-2">
                    <div className="">
                      <Select
                        IconComponent={KeyboardArrowDown}
                        fullWidth
                        value={record_type}
                        onChange={(e) => setRecordType(e.target.value)}
                        className="mb-2 bg-[#F7F7F8]"
                        sx={{
                          fontSize: "13px",
                          padding: "2px 8px", // Adjust padding here
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          "& .MuiSelect-select": {
                            padding: "2px 8px", // Adjust padding for the text inside Select
                          },
                        }}
                      >
                        <MenuItem value="upload_mp3">Upload MP3</MenuItem>
                        <MenuItem value="record_now">Record Now</MenuItem>
                      </Select>
                    </div>

                    <div className=" items-center w-full">
                      <div className="lg:flex-1 ">
                        {record_type === "upload_mp3" && (
                          <div className=" flex items-center space-x-4  mb-2 ">
                            <input
                              hidden
                              type="file"
                              id="upload_record"
                              accept=".mp3, .m4a, .wav"
                              onChange={(e) => {
                                const file = e.target.files[0];

                                const maxSize = 25 * 1024 * 1024; // 5 MB in bytes

                                if (file) {
                                  // Check file size
                                  if (file.size > maxSize) {
                                    alert(
                                      "Uploaded file too large. Please upload a file less than 25MB"
                                    );
                                    e.target.value = ""; // Clear the file input
                                    setUploadedFile(null);
                                  } else {
                                    const fileExtension = file.name
                                      .split(".")
                                      .pop()
                                      .toLowerCase();
                                    const allowedExtensions = [
                                      "mp3",
                                      "m4a",
                                      "wav",
                                    ];
                                    if (
                                      !allowedExtensions.includes(fileExtension)
                                    ) {
                                      alert(
                                        "Unsupported file type detected. Please upload mp3, m4a, or wav."
                                      );
                                      e.target.value = ""; // Clear the file input
                                    } else {
                                      setUploadedFile(file); // Set the uploaded file if valid
                                    }
                                  }
                                }
                              }}
                            />
                            <img
                              src="/icons/upload.png"
                              className="lg:w-[50px] w-[30px] "
                              onClick={() => {
                                document
                                  .getElementById("upload_record")
                                  .click();
                              }}
                            />

                            <div className="lg:text-[14px] text-[13px] italic ">
                              {" "}
                              {uploadedFile
                                ? uploadedFile.name
                                : "No file uploaded"}{" "}
                            </div>
                          </div>
                        )}

                        {record_type === "record_now" && (
                          <div className="flex items-center space-x-1 mb-2 lg:mb-2">
                            <div
                              className=" audio-input-ui "
                              style={{ width: "100%" }}
                            >
                              <button
                                className={`record-button ${buttonState}`}
                                onClick={handleClick}
                              ></button>
                              <span className="audio-timer">
                                {formatTime(time)}/{formatTime(maxTime)}
                              </span>
                            </div>

                            {buttonState === "play" && (
                              <DeleteOutline
                                className="lg:w-[17px] w-[15px] cursor-pointer"
                                onClick={() => {
                                  restartRecording();
                                }}
                              />
                            )}
                          </div>
                        )}
                      </div>

                      <div className="lg:w-[100%] w-full lg:mr-5 mb-2 lg:mb-0">
                        <InputBase
                          placeholder="Recording name"
                          value={recording_data.title}
                          onChange={(e) =>
                            setRecordingData({
                              ...recording_data,
                              title: e.target.value,
                            })
                          }
                          sx={{
                            bgcolor: "#F7F7F8",
                            width: "100%",
                            px: 2,
                            fontSize: "14px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="flex justify-center  pb-4 space-x-2">
                <Button
                  disabled={
                    (forward_action === 2 &&
                      (loader ||
                        (record_type === "upload_mp3" && !uploadedFile) ||
                        (record_type === "record_now" && !audioBlob))) ||
                    (forward_action === 1 && forward_number.length <= 1)
                      ? true
                      : false
                  }
                  variant="contained"
                    color="primary"
                    sx={{                    py: "6px",
                    px: "30px",
                    borderRadius: "7px",
                    fontSize: { lg: "14px", xs: "13px" },
                    width: "fit",
                  }}
                  onClick={() => {
                    localStorage.setItem("cameFromRegister", "true");
                    if (forward_action === 1) {
                      if (code === verificationCodeConfirmation) {
                        completeOnboardingforFowardedCall();
                        setErrormsg(null);
                        setErrorMsg(null);
                      } else {
                        setErrormsg(
                          "The verification code does not match, please verify number."
                        );
                        window.scrollTo({
                          top: 0,
                          behavior: "smooth",
                        });
                      }
                    } else {
                      if (recording_data.title.length < 1) {
                        setErrormsg("no record title");
                      } else {
                        completeOnboardingforFowardedCall();
                        setErrormsg(null);
                        setErrorMsg(null);
                      }
                    }
                  }}
                >
                  {loader ? (
                    <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                  ) : (
                    " Next"
                  )}
                </Button>
              </div>
            </div>
          )}
            </div>
          </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Register;
